import { CircularProgress } from '@material-ui/core';
import { FC } from 'react';
import styles from './Loading.module.css';

export const Loading: FC = () => (
  <div className={styles.loading}>
    <CircularProgress style={{ color: '#A01820' }} />
  </div>
);
